
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.011 44.944a4.126 4.126 0 01-3.747-2.344H22.8a4.157 4.157 0 11-7.247-4.036l-5.7-7.994a4.259 4.259 0 01-.68.055 4.144 4.144 0 110-8.287 4.272 4.272 0 01.815.079l5.5-8.131a4.164 4.164 0 117.542-3.411h7.01a4.172 4.172 0 018.138 1.277 4.1 4.1 0 01-.747 2.365l5.589 7.923a4.248 4.248 0 01.913-.1 4.143 4.143 0 11-1.05 8.151l-5.208 8.345a4.131 4.131 0 01-3.664 6.107zm-7.463-15.1l-4.324 8.279a4.243 4.243 0 01.8 1.42h7.017a4.382 4.382 0 01.819-1.445zm7.463 6.826a4.235 4.235 0 011.262.193l5.118-8.2a3.1 3.1 0 01-.327-.65H29.072l4.528 8.672c.139-.011.271-.016.411-.016zm-20.974-8.658a3.465 3.465 0 01-.542.96l5.575 7.813a4.341 4.341 0 01.982-.118c.142 0 .287.007.443.022l4.527-8.678zm20.593-11.73l-4.525 8.672h10.957a4.851 4.851 0 01.41-.776l-5.617-7.966a4.278 4.278 0 01-.844.086 3.794 3.794 0 01-.381-.017zm-15.687-.132L12.57 24.1a3.784 3.784 0 01.467.858h10.951l-4.523-8.678a4.835 4.835 0 01-.413.017 4.281 4.281 0 01-1.109-.147zM22.8 14a4.323 4.323 0 01-.594.884l4.342 8.305 4.331-8.289a4.434 4.434 0 01-.615-.9H22.8z","fill":"#222"}})])
          )
        }
      }
    